import React from "react";
import VideoCallIcon from "@material-ui/icons/VideoCall";
import SecurityIcon from "@material-ui/icons/Security";
import ScheduleIcon from "@material-ui/icons/Schedule";
import { LANDING_CONFIG } from "../../config/landingConfig";

const FeatureCard = ({ feature, index }) => {
  const IconComponent = getIconComponent(feature.icon);
  
  return (
    <div 
      className="feature-card" 
      style={{ animationDelay: `${index * 0.2}s` }}
      role="article"
      aria-labelledby={`feature-title-${feature.id}`}
    >
      <div className={`feature-icon gradient-${getGradientNumber(feature.gradient)}`}>
        <IconComponent style={{ fontSize: '2.5rem', color: 'white' }} aria-hidden="true" />
      </div>
      <h3 id={`feature-title-${feature.id}`} className="feature-title">
        {feature.title}
      </h3>
      <p className="feature-description">
        {feature.description}
      </p>
    </div>
  );
};

const getIconComponent = (iconName) => {
  const iconMap = {
    VideoCallIcon: VideoCallIcon,
    SecurityIcon: SecurityIcon,
    ScheduleIcon: ScheduleIcon,
  };
  return iconMap[iconName] || VideoCallIcon;
};

const getGradientNumber = (gradientName) => {
  const gradientMap = {
    primary: 1,
    secondary: 2,
    tertiary: 3,
    quaternary: 4,
  };
  return gradientMap[gradientName] || 1;
};

const FeaturesSection = () => {
  const { features } = LANDING_CONFIG;

  return (
    <section className="features-section" aria-labelledby="features-title">
      <h2 id="features-title" className="section-title">
        {features.title}
      </h2>
      <div className="features-grid" role="list">
        {features.items.map((feature, index) => (
          <FeatureCard 
            key={feature.id} 
            feature={feature} 
            index={index}
            role="listitem"
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;